export const api = {
	manageApiUrl: "https://manage-api.konfhub.com",
	authApiUrl: "https://api.konfhub.com",
	apiUrl: "https://api.konfhub.com",
	pollerApiUrl: "https://regional-api.konfhub.com"
};
